import axios, { AxiosError, AxiosResponse, HttpStatusCode } from 'axios';
import Cookies from 'js-cookie';
import { UserManager } from 'oidc-client-ts';

import { getAccessToken } from '@/services/tokenService';
import { appConfig } from './config';
// import { DEFAULT_TIMEOUT_AXIOS } from './constants';

const userManager = new UserManager(appConfig.settings);

const BASE_URL_APP = import.meta.env.VITE_API_APP_URL;

const getToken = (): string | undefined => {
    const accessToken = Cookies.get('access_token') || '';
    return accessToken;
};

const isExpiredToken = (): boolean => {
    const expiredTime = Cookies.get('expired_time') || '';
    if (!expiredTime) {
        return true; // If no expiration time is found, treat as expired
    }

    const isExpired = Date.now() / 1000 >= parseInt(expiredTime, 10);
    return isExpired;
};

const axiosInstance = axios.create({
    baseURL: BASE_URL_APP,
    // timeout: DEFAULT_TIMEOUT_AXIOS,
});

axiosInstance.interceptors.request.use(
    (config) => {
        if (isExpiredToken()) {
            setTimeout(async () => {
                await userManager.clearStaleState();
                await userManager.signoutRedirect();
            }, 3000);
            throw Error('Your session has expired. Please log in again to continue.');
        }

        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    async (error: AxiosError) => {
        const originalRequest = error.config as any;
        if (error.response?.status === HttpStatusCode.Unauthorized && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await getAccessToken();
                axiosInstance.defaults.headers['Authorization'] = `Bearer ${newToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                // redirect to login
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
